import { CompanyStatsAPI } from '@business/api/company_stats';
import { CompanyStatsModuleResponse } from '@business/entities/company_stats';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { SettingsConfig } from '@core/utils/config';
import { Repository } from '@core/utils/repository';
import { tap } from 'rxjs/operators';

export class CompanyStatsBloc extends BaseBloc {
  private readonly itemRepo = new Repository<CompanyStatsModuleResponse>({
    getItemId: module => module.id,
  });

  readonly modules$ = this.itemRepo.items$;

  readonly selectModule = this.itemRepo.selectItem;

  onReset() {
    this.itemRepo.reset();
  }

  fetchStats = (date?: number) => {
    return CompanyStatsAPI.fetchModules(date).pipe(this.itemRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_stats_error') }));
  };

  updateNotifyEmails = (emails: string[]) => {
    return CompanyStatsAPI.updateNotifyEmails(emails).pipe(
      tap(settings => SettingsConfig.set(settings)),
      handleMessage({ error: requestMessage('esc_account_error'), success: requestMessage('stats_saved') }),
    );
  };
}
